export const DEVICE = {
    MOBILE: 'MOBILE',
    DESKTOP: 'DESKTOP'
}

export function isDesktopDevice(device: string) {
    return device.toUpperCase() === DEVICE.DESKTOP;
}

export function isMobileDevice(device: string) {
    return device.toUpperCase() === DEVICE.MOBILE;
}